// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthorSmall_wrapper__E2V5R","image":"AuthorSmall_image__hnINb","name":"AuthorSmall_name__r0Dor"};